export const INIT_BLOG_FORM_DATA = {
  title: "",
  content: "",
} as const;
